export const equipmentQueryKeys = {
    all: ['equipment'] as const,
    data: () => [...equipmentQueryKeys.all, 'data'] as const,
    totalInfo: () => [...equipmentQueryKeys.all, 'totalInfo'] as const,
    warehouseList: () => [...equipmentQueryKeys.all, 'warehouseList'] as const,
    warehouseTotalInfo: (warehouseId: number) =>
        [...equipmentQueryKeys.all, 'warehouseTotalInfo', warehouseId] as const,
    availableProjects: () => [...equipmentQueryKeys.all, 'availableProjects'] as const,
};
